import { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import {
  Box,
  IconButton,
  Modal,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Base from "../../Base/views/Base";
import LinkIcon from "@mui/icons-material/Link";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { BASE_URL } from "../../../Constants/baseConstant";
import {
  getDomain,
  getUserData,
  getUserId,
} from "../../Base/helper/baseFunctions";
import { QRCodeCanvas } from "qrcode.react";
import ShareIcon from "@mui/icons-material/Share";
import GetAppIcon from "@mui/icons-material/GetApp";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { GetCanteenRegionAction } from "../../../../store/Employee/Canteen/Action";

const CanteenRegion = () => {
  const dispatch = useDispatch();
  const { canteenRegionsLoading, canteenRegionsData } = useSelector(
    (state) => state?.EmployeeReducer?.EmployeeCanteenReducer
  );
  const { company_logo } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
  useEffect(() => {
    dispatch(GetCanteenRegionAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isQRModalOpen, setQRModalOpen] = useState(false);
  const [region, setRegion] = useState("");
  const [portalLink, setPortalLink] = useState("https://meepl.day");
  const [copyLink, setCopyLink] = useState(false);

  const qrRef = useRef(null);
  const handleGenereate = (option, id, region) => {
    const payload = {
                user_id: getUserId(),
                canteen_management_regions_pk: id,
                image: company_logo,
                companyFullName: getUserData()?.company_full_name,
                region
            };
      let canteen_token = btoa(JSON.stringify(payload));
    if (option === "qr") {
      return `${BASE_URL}/canteen-management-portal/${getDomain()}/${canteen_token}`;
    } else {
      navigator.clipboard.writeText(
        `${BASE_URL}/canteen-management-portal/${getDomain()}/${canteen_token}`
      );
    }
  };
  const handleGenerateLink = (type, data) => {
    const id = data?.canteen_management_regions_pk || "";
    const region = data?.region || "";
    if (type === "qr") {
      const link = handleGenereate("qr", id, region);
      setPortalLink(link);
      setRegion(data?.region);
      setQRModalOpen(true);
    } else if (type === "link") {
      setCopyLink(true);
      handleGenereate("link", id, region);
    }
  };

  // Download QR Code as an image
  const downloadQR = () => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const qrCanvas = qrRef.current.querySelector("canvas");
    if (!qrCanvas) return;

    const width = 250;
    const height = 320;
    const scaleFactor = 3;
    canvas.width = width * scaleFactor;
    canvas.height = height * scaleFactor;
    ctx.scale(scaleFactor, scaleFactor);

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "black";
    ctx.font = "18px Arial";
    ctx.textAlign = "center";
    ctx.fillText("Scan to view canteen portal", width / 2, 40);

    ctx.font = "16px Arial";
    ctx.fillText(region, width / 2, 60);

    ctx.drawImage(qrCanvas, 25, 70, 200, 200);

    ctx.fillStyle = "grey";
    ctx.font = "bold 12px Arial";
    ctx.textAlign = "center";
    ctx.fillText("powered by Meepl", width / 2, 300);
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = "canteen-portal.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // Share QR Code using Web Share API
  const shareQR = async () => {
    if (!qrRef.current) return;
    const qrCanvas = qrRef.current.querySelector("canvas");
    if (!qrCanvas) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const width = 250;
    const height = 320;
    const scaleFactor = 3;
    canvas.width = width * scaleFactor;
    canvas.height = height * scaleFactor;
    ctx.scale(scaleFactor, scaleFactor);
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "black";
    ctx.font = "18px Arial";
    ctx.textAlign = "center";
    ctx.fillText("Scan to view canteen portal", width / 2, 40);

    ctx.font = "16px Arial";
    ctx.fillText(region, width / 2, 60);

    ctx.drawImage(qrCanvas, 25, 70, 200, 200);

    ctx.fillStyle = "grey";
    ctx.font = "bold 12px Arial";
    ctx.textAlign = "center";
    ctx.fillText("powered by Meepl", width / 2, 300);

    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const file = new File([blob], "canteen-portal.png", {
        type: "image/png",
      });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({
          title: "Canteen Portal",
          text: "Scan to view canteen portal",
          files: [file],
        });
      } else {
        toast.error("Sharing is not supported on this device.");
      }
    }, "image/png");
  };

  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto" }}>
        <Box>
          <MaterialTable
            isLoading={canteenRegionsLoading}
            columns={[
              {
                title: "Entry Point",
                field: "region",
                headerStyle: {
                  width: "15%",
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  width: "15%",
                  textAlign: "start",
                  padding: "7px 0px 7px 13px",
                },
              },
              {
                field: "link",
                title: "Access Link",
                headerStyle: {
                  width: "15%",
                  padding: "5px 0px 5px 10px",
                  textAlign: "center",
                },
                cellStyle: {
                  width: "15%",
                  textAlign: "center",
                  padding: "7px 0px 7px 10px",
                },
                render: (rowData) => (
                  <Tooltip title="Generate Link">
                    <IconButton
                      onClick={() => handleGenerateLink("link", rowData)}
                    >
                      <LinkIcon />
                    </IconButton>
                  </Tooltip>
                ),
              },
              {
                field: "qr",
                title: "QR Code",
                headerStyle: {
                  width: "15%",
                  padding: "5px 0px 5px 10px",
                  textAlign: "center",
                },
                cellStyle: {
                  width: "15%",
                  textAlign: "center",
                  padding: "7px 0px 7px 10px",
                },
                render: (rowData) => (
                  <Tooltip title="Generate QR Code">
                    <IconButton
                      onClick={() => handleGenerateLink("qr", rowData)}
                    >
                      <QrCodeIcon />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            data={canteenRegionsData}
            options={{
              maxBodyHeight: "calc(100vh - 185px)",
              minBodyHeight: "calc(100vh - 185px)",
              rowStyle: {
                fontSize: "13px",
                height: "45px",
              },
              headerStyle: {
                padding: "7px 10px 7px 13px",
                fontWeight: "bold",
              },
              sorting: false,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: false,
              showTitle: true,
              exportAllData: false,
              exportButton: false,
            }}
            title="Register"
          />
          <Snackbar
            open={copyLink}
            onClose={() => setCopyLink(false)}
            autoHideDuration={2000}
            message="Copied to clipboard"
          />
          <Modal
            open={isQRModalOpen}
            onClose={() => {
              setQRModalOpen(false);
              setPortalLink("https://meepl.day");
              setRegion("");
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                borderRadius: 1,
                p: 2,
                boxShadow: 24,
                maxWidth: 300,
                width: "100%",
                textAlign: "center",
              }}
            >
              <IconButton
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                }}
                onClick={() => {
                  setQRModalOpen(false);
                }}
              >
                <CloseIcon />
              </IconButton>
              <Typography mt={3} mb={1} variant="h4">
                Scan to view canteen portal
              </Typography>
              <Typography mt={1} mb={2} variant="h5">
                {region || ""}
              </Typography>
              <Box sx={{ mb: 1 }} ref={qrRef}>
                <QRCodeCanvas value={portalLink} size={240} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "25px",
                }}
              >
                <IconButton className="mpl-primary-btn" onClick={shareQR}>
                  <ShareIcon />
                </IconButton>
                <IconButton className="mpl-primary-btn" onClick={downloadQR}>
                  <GetAppIcon />
                </IconButton>
              </Box>
            </Box>
          </Modal>
        </Box>
      </Box>
    </Base>
  );
};

export default CanteenRegion;
